import React from 'react';
import {Row} from 'antd';
import commonExtendsHOC from '../commonExtendsHOC';

export default commonExtendsHOC(Row);